import React from 'react';
import * as PropTypes from 'prop-types';
import BetaIcon, { IconSizes } from '../Icons/Icon';

const CustomRadioOption = (props) => {
  const { data, innerRef, innerProps, selected } = props;

  return (
    <label className="custom-radio-btn" ref={innerRef} {...innerProps} key={data.value}>
      <input
        type="radio"
        name="custom-option"
        checked={data.label === selected}
      />
      <span className="radio-tick"></span>
      <p className="option-name">{data.label}</p>
    </label>
  );
};
CustomRadioOption.propTypes = {};

const CustomIconOption = (props) => {
  const { data, innerRef, innerProps } = props;

  return (
    <div ref={innerRef} {...innerProps} className="d-flex items-center pr-3xs pl-3xs pt-3xs pb-3xs gap-3xs">
      {data && data.icon && <BetaIcon name={data.icon} size={IconSizes[16]} />}
      <span className='text-left'>{data.label}</span>
    </div>
  );
};
CustomIconOption.propTypes = {};

export { CustomRadioOption, CustomIconOption };


